import React from 'react'
import { ControllingPdfColumn } from '@myapp/contract'
import { EXPORT_COLUMNS } from '../model/controllingExport.constants'

interface ExportColumnChecklistProps {
  checked: Set<ControllingPdfColumn>
  onToggle: (key: ControllingPdfColumn) => void
}

const CheckboxIcon: React.FC<{ checked: boolean }> = ({ checked }) =>
  checked ? (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="22" height="22" rx="5" fill="#124093" />
      <path d="M5.5 11.5L9 15L16.5 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ) : (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="20" height="20" rx="4" stroke="#124093" strokeWidth="2" />
    </svg>
  )

export const ExportColumnChecklist: React.FC<ExportColumnChecklistProps> = ({ checked, onToggle }) => (
    <div className="flex flex-col border-2 border-[#124093] py-2.5 rounded-xl min-w-[250px]">
      {EXPORT_COLUMNS.map((col) => (
        <div
          key={col.key}
          className="flex flex-row items-center justify-between cursor-pointer px-4 py-2"
          onClick={() => onToggle(col.key)}
        >
          <div className="shrink-0">
            <CheckboxIcon checked={checked.has(col.key)} />
          </div>
          <span className="text-sm font-bold text-[#124093]">{col.label}</span>
        </div>
      ))}
    </div>
)
